// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2pO5t","subheader":"ReorderModal_subheader__3wfvX","listWrap":"ReorderModal_listWrap__1w3WN"};